<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.pendingReceives'), $t('text.list')]">
        <el-button
          v-if="Permit.extendModels().includes('pms')"
          type="primary"
          size="mini"
          @click="$router.push('/normal/lms/pending-receives/purchase')"
        >
          {{ $t("menu.unDeliveryPurchases") }}
        </el-button>
        <el-button
          v-if="Permit.extendModels().includes('mes')"
          type="warning"
          size="mini"
          @click="$router.push('/normal/lms/pending-receives/manufacture')"
        >
          {{ $t("menu.unQaWorkerOrders") }}
        </el-button>
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.serialNo"
            :placeholder="$t('text.serialNo')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.color"
            :placeholder="$t('product.color')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.size"
            :placeholder="$t('product.size')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.specJson"
            :placeholder="$t('product.specJson')"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            size="small"
            v-model.trim="searchForm.supplierName"
            filterable
            clearable
            :placeholder="$t('menu.suppliers')"
          >
            <el-option
              v-for="supplier in suppliers"
              :key="supplier.id"
              :label="supplier.name"
              :value="supplier.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.receiver"
            :placeholder="$t('returnBack.receiverName')"
          ></el-input>
        </el-form-item>
        <date-range
          v-model="searchForm"
          type="datetime"
          field="receiveAt"
          :start-placeholder="$t('rules.startAt', [$t('returnBack.receiveAt')])"
          :end-placeholder="$t('rules.endAt', [$t('returnBack.receiveAt')])"
        />
        <date-range
          v-model="searchForm"
          type="datetime"
          field="finishAt"
          :start-placeholder="$t('rules.startAt', [$t('purchase.finishAt')])"
          :end-placeholder="$t('rules.endAt', [$t('purchase.finishAt')])"
        />
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.handle"
            :placeholder="$t('text.handle')"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button
              v-if="Permit.canActions('receiveView')"
              type="primary"
              size="mini"
              @click="batchAction('batchReceive')"
            >
              {{ $t("action.receive") }}
            </el-button>
            <el-button
              v-if="Permit.canActions('receiveView')"
              class="button-blue"
              size="mini"
              @click="batchAction('batchReceiveScan')"
            >
              {{ $t("action.scanReceive") }}
            </el-button>
            <el-button
              v-if="Permit.canActions('receiveReceiveQuality')"
              type="success"
              size="mini"
              @click="batchAction('batchReceiveAndQuality')"
            >
              {{ $t("action.receiveAndQuality") }}
            </el-button>

            <el-button
              v-if="
                Permit.extendModels().includes('wms') &&
                Permit.canActions('receiveReceiveQualityPush') &&
                Permit.currentTenant().config.invNeedPickPush
              "
              type="warning"
              size="mini"
              @click="batchAction('batchReceiveAndQualityAndPush')"
            >
              {{ $t("action.receiveAndQualityAndPush") }}
            </el-button>
            <el-button
              v-if="
                !Permit.isFreeEdition() &&
                Permit.canActions('receiveReceiveQualityDelivery')
              "
              type="danger"
              size="mini"
              @click="batchAction('batchReceiveAndQualityAndDelivery')"
            >
              {{ $t("action.receiveAndQualityAndDelivery") }}
            </el-button>
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}，
              {{ pager.productNoQty }} 款 {{ pager.qtyTotal }} 件
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :checkbox-config="{ reserve: true, checkMethod: checCheckboxMethod }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        id="receivesTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="associateSerialNo"
          :title="$t('stock.associateSerialNo')"
          min-width="150"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            <span
              v-if="
                ['purchase', 'workOrder', 'order'].includes(row.associateType)
              "
              class="blue"
              @click="showRow(row)"
            >
              {{ row.associateSerialNo }}
            </span>
            <span v-else>{{ row.associateSerialNo }}</span>

            <div class="font10">
              {{ $t("text.type") }}：{{ $t("receiveTypes." + row.type) }}
              <span v-if="row.canReceiveAndDeliver" class="green">
                (销售单)
              </span>
              <span v-else class="grey-shallow">
                <span v-if="['inventoryRework'].includes(row.type)">
                  ({{ $t("reworkTypes.inventory") }})
                </span>
                <span v-if="['returnBack'].includes(row.type)">
                  ({{ $t("menu.returnBacks") }})
                </span>
                <span
                  v-if="!['returnBack', 'inventoryRework'].includes(row.type)"
                >
                  ({{ $t("menu.replenishs") }})
                </span>
              </span>
            </div>
            <div
              v-if="
                row.otherInfoJson != null &&
                row.otherInfoJson != '' &&
                row.otherInfoJson != '[]'
              "
            >
              <div
                v-if="
                  JSON.parse(row.otherInfoJson).find(
                    (o) => o.name == '供应商'
                  ) != null
                "
                class="font10"
              >
                {{ $t("menu.suppliers") }}：{{
                  JSON.parse(row.otherInfoJson).find((o) => o.name == "供应商")
                    .value
                }}
              </div>
              <div
                v-if="
                  JSON.parse(row.otherInfoJson).find((o) => o.name == '客户') !=
                  null
                "
                class="font10"
              >
                {{ $t("menu.customers") }}：{{
                  JSON.parse(row.otherInfoJson).find((o) => o.name == "客户")
                    .value
                }}
              </div>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
          sortable
        >
          <template v-slot="{ row }">
            <el-popover
              v-if="
                row.otherInfoJson != null &&
                row.otherInfoJson != '' &&
                row.otherInfoJson != '[]'
              "
              placement="right"
              width="600"
              trigger="click"
            >
              <div
                v-for="(item, itemIdx) of JSON.parse(row.otherInfoJson)"
                :key="itemIdx"
                class="lineH24"
              >
                {{ item.name }}：
                <span v-if="['备注', '制作工艺'].includes(item.name)">
                  <raw-html :content="item.value" type="richText" />
                </span>
                <span v-if="item.name == '附件'">
                  <a
                    v-if="item.value"
                    class="fr blue"
                    target="_blank"
                    :href="item.value"
                  >
                    {{ $t("action.downloadAttatchment") }}
                  </a>
                </span>
                <span v-if="!['备注', '制作工艺', '附件'].includes(item.name)">
                  {{ item.value }}
                </span>
              </div>
              <span slot="reference" class="popover-reference">
                {{ row.productNo }}
              </span>
            </el-popover>
            <span v-else> {{ row.productNo }} </span>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="50"
        />
        <vxe-table-column :title="$t('receive.receiver')" min-width="120">
          <template v-slot="{ row }">
            {{ row.receiver }}
            <div class="font10">{{ row.receiveAt }}</div>
            <div class="font10" v-if="row.finishAt != null">
              {{ $t("procure.finishAt") }}:{{ row.finishAt }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="receiveQuantity"
          :title="$t('order.receiveQuantity')"
          min-width="80"
        />

        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="8"
              type="richText"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="specJson"
          :title="$t('product.specJson')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <attribute :content="row.specJson" :number="12" />
          </template>
        </vxe-table-column>
        <vxe-table-column :title="$t('text.handle')" min-width="80">
          <template v-slot="{ row }">
            {{ row.handler }}
            <div class="font10">{{ row.handleDept }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          width="110"
          sortable
        />
        <vxe-table-column
          v-if="!Permit.isFreeEdition()"
          field="action"
          :title="$t('text.action')"
          width="80"
          fixed="right"
        >
          <template v-slot="{ row }">
            <el-button
              v-if="
                row.canChangeSpec == true && row.quantity > row.receiveQuantity
              "
              type="text"
              size="mini"
              @click="receiveChangeSize(row)"
              >{{ $t("action.receiveChangeSize") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('action.receive')"
      width="60%"
      v-if="batchReceiveDF"
      :visible.sync="batchReceiveDF"
      :close-on-click-modal="false"
    >
      <batch-receive
        :items="selectRecords"
        @close="batchReceiveDF = false"
        @updateData="batchActionClose"
      ></batch-receive>
    </el-dialog>
    <el-dialog
      :title="$t('action.receiveAndQuality')"
      width="60%"
      v-if="batchReceiveAndQualityDF"
      :visible.sync="batchReceiveAndQualityDF"
      :close-on-click-modal="false"
    >
      <batch-receive-and-quality
        :items="selectRecords"
        @close="batchReceiveAndQualityDF = false"
        @updateData="batchActionClose"
      ></batch-receive-and-quality>
    </el-dialog>

    <el-dialog
      :title="$t('action.receiveAndQualityAndPush')"
      width="60%"
      v-if="batchReceiveAndQualityAndPushDF"
      :visible.sync="batchReceiveAndQualityAndPushDF"
      :close-on-click-modal="false"
    >
      <batch-receive-and-quality-and-push
        :items="selectRecords"
        @close="batchReceiveAndQualityAndPushDF = false"
        @updateData="batchActionClose"
      ></batch-receive-and-quality-and-push>
    </el-dialog>

    <el-dialog
      :title="$t('action.receiveAndQualityAndDelivery')"
      width="60%"
      v-if="batchReceiveAndQualityAndDeliveryDF"
      :visible.sync="batchReceiveAndQualityAndDeliveryDF"
      :close-on-click-modal="false"
    >
      <batch-receive-and-quality-and-delivery
        :items="selectRecords"
        @close="batchReceiveAndQualityAndDeliveryDF = false"
        @updateData="batchActionClose"
      ></batch-receive-and-quality-and-delivery>
    </el-dialog>

    <el-dialog
      :title="$t('action.scanReceive')"
      width="60%"
      v-if="batchReceiveScanDF"
      :visible.sync="batchReceiveScanDF"
      :close-on-click-modal="false"
    >
      <batch-receive-scan
        @close="batchReceiveScanDF = false"
        @updateData="batchActionClose"
      ></batch-receive-scan>
    </el-dialog>

    <!-- 改码收货 -->
    <el-dialog
      :title="$t('action.receiveChangeSize')"
      :visible.sync="receiveChangeSizeDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form
        ref="receiveChangeSizeObjForm"
        :model="receiveChangeSizeObj"
        label-width="60px"
      >
        <el-form-item :label="$t('product.size')" :prop="'size'">
          <el-autocomplete
            size="small"
            v-model="receiveChangeSizeObj.size"
            :fetch-suggestions="querySearchSize"
            style="width: 100%"
            @select="handleSelectSize"
          />
        </el-form-item>
        <el-form-item
          :prop="'quantity'"
          :label="$t('text.quantity')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="receiveChangeSizeObj.quantity"
            :placeholder="receiveChangeSizeObj._maxQuantity"
          />
        </el-form-item>
        <el-form-item :label="$t('text.remark')">
          <el-input
            size="small"
            v-model.trim="receiveChangeSizeObj.remark"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="receiveChangeSizeSubmitDoing"
          size="small"
          @click="receiveChangeSizeSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="receiveChangeSizeDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <drawer
      :title="$t('text.view')"
      v-if="showDF"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
    >
      <show-purchase
        :id="currentRowId"
        v-if="['purchase'].includes(currentRowType)"
      />
      <show-order
        :id="currentRowId"
        v-if="['order', 'workOrder'].includes(currentRowType)"
      />
    </drawer>
  </div>
</template>

<script>
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import DateRange from "@/components/DateRange";
import RawHtml from "@/components/RawHtml";
import Receive from "@/api/receive.js";
import Product from "@/api/product.js";
import Supplier from "@/api/supplier.js";

//
import BatchReceive from "./batchReceive";
import BatchReceiveAndQuality from "./batchReceiveAndQuality";
import BatchReceiveAndQualityAndPush from "./batchReceiveAndQualityAndPush";
import BatchReceiveAndQualityAndDelivery from "./batchReceiveAndQualityAndDelivery";
import BatchReceiveScan from "./batchReceiveScan";

import ShowPurchase from "./showPurchase";
import ShowOrder from "./showOrder";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    RawHtml,
    BatchReceive,
    BatchReceiveAndQuality,
    BatchReceiveAndQualityAndPush,
    BatchReceiveAndQualityAndDelivery,
    BatchReceiveScan,
    ShowPurchase,
    ShowOrder,
  },

  data() {
    return {
      Util: Util,
      sorter: {
        sortBy: "receives_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        productNo: "receives_productNo",
        createAt: "receives_createAt",
      },
      narrows: [
        [
          {
            label: this.$t("receive.receiveInfo"),
            items: [
              {
                label: this.$t("receiveInfos.yes"),
                key: "yes",
                condition: { finish: "yes" },
              },
              {
                label: this.$t("receiveInfos.no"),
                key: "no",
                condition: { finish: "no" },
              },
            ],
          },
        ],
        [
          {
            label: this.$t("text.type"),
            items: Receive.types_all.map((type) => {
              return {
                label: this.$t("receiveTypes." + type),
                key: type,
                condition: { type: type },
              };
            }),
          },
        ],
      ],
      initFilter: "no",
      searchForm: {
        serialNo: null,
        profuctNo: null,
        color: null,
        size: null,
        supplierName: null,
        receiver: null,
        receiveAtStartAt: null,
        receiveAtEndAt: null,
        finishAtStartAt: null,
        finishAtEndAt: null,
        handle: null,
      },
      suppliers: [],
      //
      batchReceiveDF: false,
      batchReceiveAndQualityDF: false,
      batchReceiveAndQualityAndPushDF: false,
      batchReceiveAndQualityAndDeliveryDF: false,
      batchReceiveScanDF: false,
      //
      row: null,
      receiveChangeSizeDF: false,
      receiveChangeSizeObj: {
        quantity: null,
        remark: null,
        size: null,
      },
      productNoSizes: [],
      receiveChangeSizeSubmitDoing: false,
      //
      currentRowId: null,
      currentRowType: null,
      showDF: false,
      //
    };
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    self.getSuppliers();
  },
  methods: {
    getSuppliers() {
      const self = this;
      Supplier.findByTenantId().then(function (res) {
        if (res.status == 200) {
          self.suppliers = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //
    showRow(row) {
      this.currentRowId = row.associateId;
      this.currentRowType = row.associateType;
      this.showDF = true;
    },
    //
    receiveChangeSize(row) {
      const self = this;
      self.row = row;
      self.receiveChangeSizeObj.quantity = row.quantity - row.receiveQuantity;
      self.receiveChangeSizeObj._maxQuantity =
        row.quantity - row.receiveQuantity;
      Product.findByProductNo({
        productNo: row.productNo,
      }).then(function (res) {
        if (res.data.code === 200) {
          self.productNoSizes = res.data.entity.sizes;
          self.receiveChangeSizeDF = true;
        } else {
          self.sysError();
        }
      });
    },
    // 规格
    querySearchSize(queryString, cb) {
      const self = this;
      if (queryString == null) {
        cb(
          self.productNoSizes.map((s) => {
            return { value: s };
          })
        );
      } else {
        const filterSizes = self.productNoSizes.filter(
          (c) => c.indexOf(queryString) !== -1
        );
        cb(
          filterSizes.map((s) => {
            return { value: s };
          })
        );
      }
    },
    handleSelectSize() {},
    receiveChangeSizeSubmit() {
      const self = this;
      this.$refs.receiveChangeSizeObjForm.validate((valid) => {
        if (valid) {
          if (
            !Util.regexQuantity(self.receiveChangeSizeObj.quantity) ||
            self.receiveChangeSizeObj.quantity === "0" ||
            self.receiveChangeSizeObj.quantity >
              self.receiveChangeSizeObj._maxQuantity
          ) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          self.receiveChangeSizeSubmitDoing = true;
          Receive.changeSpecsReceive(
            self.row.id,
            self.receiveChangeSizeObj
          ).then(function (res) {
            self.receiveChangeSizeSubmitDoing = false;
            self.receiveChangeSizeDF = false;
            self.receiveDF = false;
            if (res.status === 200) {
              self.loadData();

              self.sysResult(res.data);
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    batchAction(type) {
      const self = this;
      if (type == "batchReceiveScan") {
        this.batchReceiveScanDF = true;
        return;
      }
      if (type == "batchReceiveAndQualityAndPush") {
        this.batchReceiveAndQualityAndPushDF = true;
        return;
      }
      if (this.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      if (type == "batchReceive") {
        this.batchReceiveDF = true;
        return;
      }
      if (type == "batchReceiveAndQuality") {
        this.batchReceiveAndQualityDF = true;
        return;
      }

      if (type == "batchReceiveAndQualityAndDelivery") {
        for (const row of this.selectRecords) {
          if (!row.canReceiveAndDeliver) {
            self.$message({
              message: "存在库存备货的或者库存返工的产品，不能收货并发货",
              type: "warning",
            });
            return;
          }
        }
        this.batchReceiveAndQualityAndDeliveryDF = true;
        return;
      }
    },
    batchActionClose() {
      this.selectRecords = [];
      this.loadData();
      this.batchReceiveDF = false;
      this.batchReceiveAndQualityDF = false;
      this.batchReceiveAndQualityAndPushDF = false;
      this.batchReceiveAndQualityAndDeliveryDF = false;
      this.batchReceiveScanDF = false;
    },

    // 可选
    checCheckboxMethod({ row }) {
      if (row.quantity > row.receiveQuantity) {
        return true;
      }
      return false;
    },
    //
    dataProvider(params) {
      return Receive.search(params);
    },
  },
};
</script>
